import { render, staticRenderFns } from "./deductDetail.vue?vue&type=template&id=5d09311a&scoped=true"
import script from "./deductDetail.vue?vue&type=script&lang=js"
export * from "./deductDetail.vue?vue&type=script&lang=js"
import style0 from "./deductDetail.vue?vue&type=style&index=0&id=5d09311a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d09311a",
  null
  
)

export default component.exports